import '../CsvJsonInfoPages.scss';


function TechnicalData() {

    const data = [
        { field: 1, description: 'CAP ID (Int)' },
        { field: 2, description: 'Technical Data Code (Int)' },
        { field: 3, description: 'Date Effective From (Date)' },
        { field: 4, description: 'Date Effective To (Date)' },
        { field: 5, description: 'Value (Date) — Blank if not a DateTime' },
        { field: 6, description: 'Value (Float) — Blank if not a Float' },
        { field: 7, description: 'String representation of the value (Char)' },
        { field: 8, description: 'Value (Boolean) — Blank if not a Boolean' },
    ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Technical Descriptions</h1>
            <p>Provides the Technical Data information available for vehicles<br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDTechnical.txt<br />
                LIGHTS_yyyy-mm-dd_NVDTechnical.txt<br />
                HEAVIES_yyyy-mm-dd_NVDTechnical.txt<br />
                BIKES_yyyy-mm-dd_NVDTechnical.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <p>Notes<br />
                All measurements given are in metric and will be mm or kg, unless otherwise stated.
            </p>

        </div>
    );
}

export default TechnicalData;
